import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.less'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ButtonModule],
})
export class EmptyStateComponent {
    icon = input<string>('fas fa-inbox');
    message = input<string>('No records found');
    size = input<'small' | 'medium' | 'large'>('medium');
    showAction = input<boolean>(false);
    actionLabel = input<string>('Add New');
    actionClick = output<void>();
}
